import 'whatwg-fetch';

export const loadAnnotations = (token, client, documentid) => {
  var host =
    'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  if (process.env.NODE_ENV === 'development') {
    host = 'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  }
  return fetch(`${host}/annotations/${client}/${documentid}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      JWT: token
    },
    credentials: 'same-origin'
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const saveAnnotations = (token, client, documentid, annotationJSON) => {
  var host =
    'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  if (process.env.NODE_ENV === 'development') {
    host = 'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  }
  return fetch(`${host}/annotations/${client}/${documentid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      JWT: token
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      annotationJSON
    })
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const loadPresets = (token, sessionid, client) => {
  var host =
    'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  if (process.env.NODE_ENV === 'development') {
    host = 'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  }
  return fetch(`${host}/sessionpreferences/${sessionid}/${client}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      JWT: token
    },
    credentials: 'same-origin'
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const savePresets = (token, sessionid, presetJson, client) => {
  var host =
    'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  if (process.env.NODE_ENV === 'development') {
    host = 'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  }
  return fetch(`${host}/sessionpreferences/${sessionid}/${client}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      JWT: token
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      presetJson
    })
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const retrieveExportData = () => {
  return fetch('/exportData.json')
    .then(response => {
      return response.json();
    })
    .then(json => {
      console.log(json);
      return json;
    });
};
